export const sobre = {
  hero: {
    label: 'Sobre',
    title: 'FGT Capital',
    subtitle: 'Engenharia patrimonial com rigor técnico e governança.',
  },
  content: {
    paragraph1: 'A FGT Capital é uma estrutura técnica dedicada à engenharia patrimonial através de consórcios regulamentados. Não somos corretora. Não prometemos contemplação. Não garantimos prazos ou retornos fixos.',
    paragraph2: 'Operamos com método: diagnóstico estrutural, análise de regulamentos, modelagem de cenários (base e stress), execução disciplinada e acompanhamento até a utilização do crédito.',
    paragraph3: 'Cada decisão patrimonial é tratada como projeto técnico. Com variáveis mapeadas, restrições identificadas e cenários modelados. Patrimônio não se improvisa. Se projeta.',
  },
  principles: {
    title: 'Nossos Princípios',
    0: {
      title: 'Método',
      description: 'Processo estruturado em 5 etapas: diagnóstico, análise, modelagem, execução e acompanhamento. Sem atalhos.',
    },
    1: {
      title: 'Governança',
      description: 'Transparência total sobre variáveis, restrições e riscos. Sem promessas. Sem garantias que não podemos cumprir.',
    },
    2: {
      title: 'Execução',
      description: 'Acompanhamento técnico até a utilização do crédito. Estratégia sem execução é teoria. Execução sem método é risco.',
    },
  },
  values: {
    title: 'O Que Nos Move',
    item1: 'Rigor técnico em cada análise. Cada regulamento é diferente. Cada grupo tem dinâmica própria. Generalizações são perigosas.',
    item2: 'Clareza sobre o que não controlamos. Contemplação depende de sorteio ou lance. Prazos variam. Custos seguem regulamento.',
    item3: 'Compromisso com a execução. Não entregamos apenas análise. Acompanhamos até a utilização do crédito.',
  },
  cta: {
    title: 'Conheça Nossa Estrutura',
    subtitle: 'Agendar um diagnóstico estratégico e entender como estruturamos decisões patrimoniais.',
    primary: 'Agendar Diagnóstico Estratégico',
    secondary: 'Falar com Especialista',
  },
};